import { useTheme } from "next-themes";
import React, { useEffect, useState } from "react";

const DarkModeSwitch = () => {

  const {theme, setTheme} = useTheme()
  const [mounted, setMounted] = useState(false)

  const handleClick = (e) => { 
    e.stopPropagation()
    setTheme(theme === 'dark' ? 'light' : 'dark')
  }

  useEffect(() => {setMounted(true)}, [])

  if(!mounted) return null

  return (
    <button onClick={handleClick}>
      <span className="w-10 h-10 rounded-full flex justify-center items-center shadow-xl bg-white-bg dark:bg-theme-dark-light dark:shadow-none">
        { theme === 'light'
          ? <svg
              width="31"
              height="39"
              className="w-5 h-5"
              viewBox="0 0 31 39"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.2646 38.9643C22.5401 38.9643 27.3584 36.2829 30.5505 31.8893C31.0227 31.2393 30.5078 30.2898 29.778 30.445C21.4798 32.2105 13.8594 25.1028 13.8594 15.7449C13.8594 10.3545 16.4425 5.39759 20.6406 2.72863C21.2878 2.31723 21.125 1.22119 20.3897 1.06945C19.3588 0.857099 18.3128 0.750174 17.2646 0.75C7.82355 0.75 0.160889 9.29679 0.160889 19.8571C0.160889 30.4041 7.81152 38.9643 17.2646 38.9643Z"
                fill="black"
              />
            </svg>
          : <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12.0006 7.5C9.52077 7.5 7.50036 9.52031 7.50036 12C7.50036 14.4797 9.52077 16.5 12.0006 16.5C14.4804 16.5 16.5008 14.4797 16.5008 12C16.5008 9.52031 14.4804 7.5 12.0006 7.5ZM23.5511 11.2734L19.1119 9.05625L20.6823 4.35C20.8932 3.7125 20.2885 3.10781 19.6556 3.32344L14.9492 4.89375L12.7272 0.45C12.4272 -0.15 11.574 -0.15 11.274 0.45L9.05669 4.88906L4.34552 3.31875C3.70799 3.10781 3.10328 3.7125 3.31891 4.34531L4.8893 9.05156L0.450022 11.2734C-0.150007 11.5734 -0.150007 12.4266 0.450022 12.7266L4.8893 14.9437L3.31891 19.6547C3.10796 20.2922 3.71268 20.8969 4.34552 20.6813L9.052 19.1109L11.2693 23.55C11.5693 24.15 12.4225 24.15 12.7225 23.55L14.9398 19.1109L19.6463 20.6813C20.2838 20.8922 20.8885 20.2875 20.6729 19.6547L19.1025 14.9484L23.5418 12.7313C24.1512 12.4266 24.1512 11.5734 23.5511 11.2734ZM16.243 16.2422C13.9038 18.5812 10.0974 18.5812 7.75819 16.2422C5.41901 13.9031 5.41901 10.0969 7.75819 7.75781C10.0974 5.41875 13.9038 5.41875 16.243 7.75781C18.5822 10.0969 18.5822 13.9031 16.243 16.2422Z"
                fill="white"
              />
            </svg>
          }
      </span>
    </button>
  );
}

export default DarkModeSwitch;
